import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from "react-router-dom";
import { postAsync, PostAsyncAnonymous } from '../../core/serviceClient';
import Utils from '../../core/Utils';
import { Box, Container } from '@mui/system';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Slide, Typography } from '@mui/material';
import Loader from '../common/Loader';
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import "../../Style.css";
import "../../Brand.css";
import "../../Responsive.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CustomerConsentOptOut = () => {
    const { BrandPath } = useParams();
    const [searchParams] = useSearchParams(); // Get query parameters
    const [loading, setLoading] = useState(false);
    const [businessId, setBusinessId] = useState("");
    const [customerId, setCustomerId] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isCustomerUnsubscribed, setIsCustomerUnsubscribed] = useState(false);

      useEffect(() => {
          const encryptedData = searchParams.get("data");
          if (encryptedData) {
            const correctedData = decodeURIComponent(encryptedData);
            getDecryptedData(correctedData);
          }
        }, [searchParams, BrandPath]);

    useEffect(() => {
        setLoading(true);
        const timer = setTimeout(() => {
            setLoading(false);
        }, 7000);

        return () => clearTimeout(timer);
    }, []);
     var body = document.body;
    body.classList.add("brandHome");

    




    const getDecryptedData = async (encryptedData) => {
        var requestBody = {
          Data: {
            EncryptedData: encryptedData,
          },
        };
        setLoading(true);
        let result = await PostAsyncAnonymous(
          "Branch/GetDecryptedString",
          requestBody
        );
        if (!Utils.IsNullOrEmptyArray(result.data)) {
          const decryptedDatatemp = result.data;
    
          const businessId = decryptedDatatemp?.split("#")[0];
          let customerId = decryptedDatatemp?.split("#")[1];
    
          setBusinessId(businessId);
          setCustomerId(customerId);
          setLoading(false);
          GetCustomerPassDetails(businessId,customerId);
          GetBusinessDetails(businessId);
        }
      };

      const GetBusinessDetails = async (BusinessId) => {
        setLoading(true);
        var requestBody = {
          Data: {
            BusinessId: BusinessId,
            Id: BusinessId
          }
        }
        let result = await PostAsyncAnonymous(
            "Branch/GetBusiness",
            requestBody
        );
        setLoading(false);
        if(!result?.error && !Utils.IsNullOrEmptyArray(result?.data)) {
            if(!Utils.IsNullOrEmpty(result?.data?.companyName)) {
                setBusinessName(result?.data?.companyName)
            }
        }

      }

      const GetCustomerPassDetails = async (BusinessId,CustomerId) => {
        setLoading(true);
        let businessCustomerId = BusinessId + CustomerId;
        var requestBody = {
          Data: {
            BusinessId: BusinessId,
            Id: businessCustomerId
          }
        }
        let result = await PostAsyncAnonymous(
            "Branch/GetCustomerPass",
            requestBody
        );
        if(!result.error && !Utils.IsNullOrEmptyObject(result?.data)) {
          let customerPass = result?.data;
          if(customerPass?.isCustomerAgreeMarketing) {
            setIsCustomerUnsubscribed(true);
          } else {
            setIsCustomerUnsubscribed(false);
          }
        }
        setLoading(false)
      }

      const handleUnsubscribe = async () => {
        if(!Utils.IsNullOrEmpty(businessId) && !Utils.IsNullOrEmpty(customerId)) {
          let obj = {
            Data: {
              BusinessId: businessId,
              CustomerId: customerId
            }
          };
          setLoading(true);
          let result = await PostAsyncAnonymous("Branch/CustomerUnsubscriptionMarket",obj);
          setLoading(false);
          if(!result.error && result.data) {
            setOpenModal(true);
            GetCustomerPassDetails(businessId,customerId)
          }
        }
      }

  const handleCloseModal = () => {
    setOpenModal(false);
  };



  return (
    <Container maxWidth="false" sx={{ paddingBottom: "8rem" }} className="xs-pd-0">
    <Loader open={loading} />
    <Dialog
    open={openModal}
    TransitionComponent={Transition}
    keepMounted
    onClose={(event, reason) => {
      if (reason === "backdropClick" || reason === "escapeKeyDown") {
        return; 
      }
      handleCloseModal(); 
    }}
    aria-describedby="alert-dialog-slide-description"
    className="booknow-modal"
    >
      <DialogTitle fontSize="2rem" fontWeight="700">
        <Typography variant="h4" sx={{fontWeight: "bold"}}>You have successfully unsubscribed from marketing messages from {businessName}.</Typography>
        <IconButton
            onClick={handleCloseModal}
            title="Close"
            sx={{ position: "absolute", right: "10px", top: "10px" }}
          >
            <CloseOutlinedIcon sx={{ fontSize: "24px" }} />
          </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
            <Typography variant="h5">You may still receive essential service-related communications when necessary.</Typography>
            <Typography sx={{mt: 2}} variant="h5">If this was a mistake, you can resubscribe at any time by contacting our support team.</Typography>
            <Typography sx={{mt: 2}} variant="h5">Thank you.</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
          <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              className="submitBtn cs-btn"
              fullWidth="true"
              onClick={handleCloseModal}
            >
              Ok
            </Button>
      </DialogActions>
    </Dialog>
    <Box
      sx={{
        border: "1px solid #dcdcdc",
        borderRadius: 2,
        padding: 3,
        backgroundColor: "#fff",
        boxShadow: 1,
        mt: 4
      }}
    >
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Confirm Unsubscribe
      </Typography>

      <Typography variant="h5" sx={{ mb: 2, mt: 3 }}>
        Are you sure you want to stop receiving marketing messages from{" "}
        <strong>{businessName}</strong>?
      </Typography>

      <Typography variant="h6" sx={{ mb: 1 }}>
        You will no longer receive promotional offers, updates, or announcements.
      </Typography>

      <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
        (Important service-related notifications will still be sent when necessary.)
      </Typography>

      <Button
        variant="contained"
        color="error"
        onClick={handleUnsubscribe}
       disabled={!isCustomerUnsubscribed}
      >
        Unsubscribe
      </Button>
    </Box>
    </Container>
  )
}

export default CustomerConsentOptOut